exports = module.exports = require("../../node_modules/.0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dh-markdown {\n  padding: 20px; }\n  .dh-markdown pre {\n    background-color: #f7f7f7;\n    padding: 8px 0;\n    margin: 12px 0;\n    color: #000; }\n  .dh-markdown table {\n    width: 100%;\n    border-collapse: collapse;\n    border-spacing: 0; }\n    .dh-markdown table thead th {\n      border: 1px solid #e9e9e9;\n      padding: 8px 16px;\n      text-align: left;\n      background-color: #f0f0f0;\n      text-align: center; }\n    .dh-markdown table td {\n      text-align: left;\n      border: 1px solid #e9e9e9;\n      padding: 8px 16px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.26.4@css-loader!./~/.1.3.3@postcss-loader!./~/.6.0.3@sass-loader/lib/loader.js!./example/home/markdown.scss
// module id = 218
// module chunks = 0